import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { RunDetailPanel } from '@/components/scout';

export const Route = createFileRoute('/scout/runs/$runId')({
  component: RunDetailPage,
});

function RunDetailPage() {
  const { runId } = Route.useParams();
  const navigate = useNavigate();
  return (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader
          title="Run Status"
          backTo="/scout/runs"
          action={{ label: 'Export', onClick: () => navigate({ to: '/scout/export' }) }}
        />
        <RunDetailPanel runId={runId} />
      </div>
    </EntitlementGate>
  );
}
